import { gql } from 'graphql-request';

import {
  SearchFilterColors,
  SearchFilterCreatedAt,
  SearchFilterID,
  SearchFilterName,
  SearchFilterNanoID,
  SearchFilterUpdatedAt,
  SearchFilterUUID
} from '../searchFiltersTypes';

import { SearchFiltersScopes } from '../searchFiltersConstants';

export type FetchCacheSearchFiltersQueryResponse<FiltersType> = {
  createdAt: SearchFilterCreatedAt;
  colors: SearchFilterColors;
  data: FiltersType;
  id: SearchFilterID;
  name: SearchFilterName;
  updatedAt: SearchFilterUpdatedAt;
  uuid: SearchFilterUUID;
  nanoId: SearchFilterNanoID;
  scope: SearchFiltersScopes;
};

export const FETCH_CACHE_SEARCH_FILTERS_QUERY = gql`
  query CacheSearchFilters(
    $filters: SearchFiltersFilters
    $sort: [SearchFiltersSortEnum!]
    $offset: Int
    $limit: Int
    $source: String
    $trackTotalHits: Boolean
  ) {
    searchFilters(
      filters: $filters
      sort: $sort
      offset: $offset
      limit: $limit
      source: $source
      trackTotalHits: $trackTotalHits
    ) {
      nodes {
        id
        uuid
        nanoId
        name
        colors
        data
        scope
        createdAt
        updatedAt
      }
      paginationInfo {
        nextPage
        totalCount
      }
      sql
    }
  }
`;
